<template>
    <div>
        <b-row>
            <b-col md="12">
                <b-card>
                    <b-row>
                        <b-col sm="12" md="4" lg="4">
                            <b-form-group :label="$t('faculty_code')">
                                {{ formData.faculty_code }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4" lg="4">
                            <b-form-group :label="$t('department_code')">
                                {{ formData.department_code }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4" lg="4">
                            <b-form-group :label="$t('program_code')">
                                {{ formData.code }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4" lg="4">
                            <b-form-group :label="$t('program_name')">
                                {{ getLocaleText(formData, 'name') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4" lg="4">
                            <b-form-group :label="$t('program_level')">
                                {{ getLocaleText(formData, 'level_text') }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4" lg="4">
                            <b-form-group :label="$t('program_language')">
                                {{ formData.language }}
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4" lg="4">
                            <b-form-group :label="$t('program_duration')">
                                {{ formData.duration }}
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" class="mt-2">
                <b-card>
                    <b-row>
                        <b-col md="12">
                            <b-table
                                :empty-filtered-text="$t('no_result')"
                                :empty-text="$t('no_result')"
                                bordered
                                striped
                                responsive
                                :items="tableData"
                                :fields="tableFields"
                                show-empty
                                class="mb-5 mt-2 table-dropdown no-scrollbar border rounded">
                                <template v-for="item in tableFields" v-slot:[`head(${item.key})`]="data">
                                    <span v-if="item.label != ''" class="cursor-pointer" v-b-tooltip.hover :title="item.label">{{ item.key }}</span>
                                </template>
                                <template v-for="(field,index) in tableFields" v-slot:[`cell(${field.key})`]="data">
                                    <div>
                                        <b-form-checkbox
                                            v-if="field.key !== 'info' && data.item[field.key]"
                                            @change="checking(field.key, data.item[field.key].id)"
                                            :id="'checkbox-'+field.key+'-'+data.item[field.key].id+'-'+data.index"
                                            v-model="data.item[field.key].status"
                                            value="checked"
                                            unchecked-value="not_checked" />
                                        <span v-else-if="index == 0" class="cursor-pointer">{{data.item.info}}</span>
                                    </div>

                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
// Services
import TyycBasicFieldOutcomesService from "@/services/TyycBasicFieldOutcomesService"
import ProgramOutcome from "@/services/ProgramOutcome"
import ProgramBasicFieldOutcomesService from "@/services/ProgramBasicFieldOutcomesService"

// Other
import { ValidationObserver, ValidationProvider } from "vee-validate";
import qs from "qs";

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    props: {
        program: {
            type: Object,
        },
    },
    data() {
        return {
            formLoading: false,
            formData: {},
            tableData: [],
            tableFields: [
                {
                    key: 'info',
                    label: ''
                }
            ],
            tyycOutcomes: null,
            status: []
        };
    },

    created() {
        this.formData = this.program
        this.getProgramOutcome()
    },

    methods: {
        getData(){
            const config = {
                params: {
                    filter: {
                        program_code: this.program.code
                    },
                    sort: 'id',
                    limit: -1
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };

            ProgramBasicFieldOutcomesService.getAll(config).then(response => {
                response.data.data.forEach(data =>{
                    let key = null
                    this.tableFields.forEach(obj =>{
                        if(obj.program_outcome_id && obj.program_outcome_id == data.program_outcome_id){
                            key = obj.key
                        }
                    })

                    this.tableData.forEach((item, index1) => {
                        if(item[key] && item[key].id == data.tyyc_basic_field_outcome_id){
                            this.$set(this.tableData[index1][key], 'status', 'checked')
                            this.$set(this.tableData[index1][key], 'complex_id', data.id)
                        }
                    })
                })
            }).catch(e => {
                this.showErrors(e)
            })
        },

        getTyycLevelOutcomes(){
            const config = {
                params: {
                    filter: {
                        program_level: this.program.level
                    },
                    sort: 'rank',
                    limit: -1
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            TyycBasicFieldOutcomesService.getAll(config).then(response => {
                const data = [];
                response.data.data.forEach((itm, index) => {
                    data.push({
                        info: (index+1).toString()+' - '+this.getLocaleText(itm, 'tyyc_basic_field_type_name')
                    })
                    let objData = {}
                    this.tableFields.forEach((item, i) => {
                        if(i > 0){
                            objData[item.key] = {
                                id: itm.id,
                                status: 'not_checked'
                            }
                        }
                    })
                    data.push({
                        info: this.getLocaleText(itm, 'outcome'),
                        ...objData
                    })
                })
                this.tableData = data;
                this.getData();
            }).catch(e => {
                this.showErrors(e)
            })
        },

        getProgramOutcome(){
            const config = {
                params: {
                    filter: {
                        program_code: this.program.code
                    },
                    sort: 'rank',
                    limit: -1
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };

            ProgramOutcome.getAll(config).then(response => {
                response.data.data.forEach((itm, index) => {
                    let kl = index + 1
                    this.tableFields.push({
                        key: kl.toString(),
                        label: this.getLocaleText(itm, 'name'),
                        program_outcome_id: itm.id
                    })
                })
            }).finally(() =>{
                this.getTyycLevelOutcomes()
            }).catch(e => {
                this.showErrors(e)
            })
        },

        checking(key, tyycBasicFieldOutcomeId){
            let formData = {
                program_outcome_id: this.tableFields.find(f => f.key === key).program_outcome_id,
                tyyc_basic_field_outcome_id: tyycBasicFieldOutcomeId
            }

            this.tableData.forEach((itm, index) => {
                if(itm[key] && itm[key].id == tyycBasicFieldOutcomeId){
                    if(itm[key].status == 'checked'){
                        if(this.checkPermission('programbasicfieldoutcome_store')){
                            ProgramBasicFieldOutcomesService.store(formData).then(response => {
                                this.$set(this.tableData[index][key], 'complex_id', response.data.data.id)
                                this.$toast.success(this.$t('api.'+response.data.message))
                            }).catch(e => {
                                this.showErrors(e)
                            })
                        } else {
                            this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
                        }
                    } else {
                        if(this.checkPermission('programbasicfieldoutcome_delete')){
                            ProgramBasicFieldOutcomesService.del(this.tableData[index][key].complex_id).then(response => {
                                this.$toast.success(this.$t('api.'+response.data.message))
                                delete this.tableData[index][key].complex_id
                            }).catch(e => {
                                this.showErrors(e)
                            })
                        } else {
                            this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
                        }
                    }
                }
            })
        }
    },
}
</script>
<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
